import React from 'react';
import SnakeDraftModule from './modules/SnakeDraftModule';
import './DraftPage.css'; // Assuming a generic DraftPage css exists

// This is a temporary component to display and test the SnakeDraftModule with mock data.
const SnakeDraftPage = () => {
  // Mock contest data that would normally come from an API call
  const mockContest = {
    tourneyID: 'snake_preview_123',
  };

  // Mock state that simulates what the WebSocket server would send
  const mockDraftState = {
    round: 1,
    pickInRound: 2,
    timeLeft: 25,
    currentPicker: { userId: 'user_123', username: 'Alice (You)' },
    availablePlayers: [
      { name: 'Player A', finish: 0, cashedFor: 0, sportSpecificData: { chipCount: 50000, icmValue: 1200, currentChipCount: 50000 } },
      { name: 'Player B', finish: 0, cashedFor: 0, sportSpecificData: { chipCount: 45000, icmValue: 1100, currentChipCount: 45000 } },
      { name: 'Player C', finish: 0, cashedFor: 0, sportSpecificData: { chipCount: 40000, icmValue: 1000, currentChipCount: 40000 } },
      { name: 'Player D', finish: 0, cashedFor: 0, sportSpecificData: { chipCount: 35000, icmValue: 900, currentChipCount: 35000 } },
      { name: 'Player E', finish: 0, cashedFor: 0, sportSpecificData: { chipCount: 30000, icmValue: 800, currentChipCount: 30000 } },
      { name: 'Player F', finish: 0, cashedFor: 0, sportSpecificData: { chipCount: 25000, icmValue: 700, currentChipCount: 25000 } },
      { name: 'Player G', finish: 0, cashedFor: 0, sportSpecificData: { chipCount: 20000, icmValue: 600, currentChipCount: 20000 } },
    ],
    entrants: [
      { userId: 'user_123', username: 'Alice (You)', team: [{ name: 'Player X', finish: 0, cashedFor: 0, sportSpecificData: { chipCount: 80000, icmValue: 1800, currentChipCount: 80000 } }] },
      { userId: 'user_456', username: 'Bob', team: [{ name: 'Player Y', finish: 0, cashedFor: 0, sportSpecificData: { chipCount: 75000, icmValue: 1700, currentChipCount: 75000 } }] },
      { userId: 'user_789', username: 'Charlie', team: [] },
    ],
    draftPicks: [
      // This structure needs to be aligned with DraftBoard's expectation.
      // For now, this is a placeholder.
    ],
  };

  return (
    <div className="draft-page-container">
      <header className="draft-page-header">
        <h1>Snake Draft Preview</h1>
        <p>This is a temporary page to showcase the new snake draft components.</p>
      </header>
      <main>
        <SnakeDraftModule contest={mockContest} mockDraftState={mockDraftState} />
      </main>
    </div>
  );
};

export default SnakeDraftPage; 